import { connect } from 'react-redux';
import ReadingSinceAndCountItem from './readingSinceAndCountItem';
import withPGTranslation from '../../../../config/withPGTranslation';

export const readingSinceAndCountItemThemes = {
  default: 'default',
  staffPick: 'staffPick',
  staffPickPs: 'staffPickPs',
  staffPickMobile: 'staffPickMobile',
  onHomePageAdvisorAvatar: 'onHomePageAdvisorAvatar',
  onHomePageSecriceContainer: 'onHomePageSecriceContainer',
  onHomePagePsiquicosServiceContainer: 'onHomePagePsiquicosServiceContainer',
  recommendCarousel: 'recommendCarousel',
  onHomePageAdvisorFromCountryAvatar: 'onHomePageAdvisorFromCountryAvatar'
};

const mapStateToProps = () => (
  {}
);

export default connect(
  mapStateToProps,
  {
  }
)(withPGTranslation(ReadingSinceAndCountItem));
